import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MultiInputStepComponent } from '../../step/multi-input-step/multi-input-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-first-name-last-name',
  templateUrl: './first-name-last-name.component.html',
  styleUrls: ['./first-name-last-name.component.scss', '../../step/step.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class FirstNameLastNameComponent extends MultiInputStepComponent implements OnInit {
  
  @ViewChild('firstName') firstNameField: ElementRef;
  @ViewChild('lastName') lastNameField: ElementRef;
  public experiment: boolean;
  private cashoutAmount: number;
  private cashoutPercentage : number;
  private regex = new RegExp("[^a-zA-Z \'\`\-]", 'g');
  public notDebtSettlement: boolean;

  ngOnInit() {
    // First Name validation
    this.controls.push(new UntypedFormControl('', [Validators.required, Validators.pattern('^\\s*[a-zA-Z \'\`\-]+\\s*$'), Validators.minLength(2)]));
    // Last Name validation
    this.controls.push(new UntypedFormControl('', [Validators.required, Validators.pattern('^\\s*[a-zA-Z \'\`\-]+\\s*$'), Validators.minLength(2)]));

    this.form.addControl('firstName', this.controls[0]);
    this.form.addControl('lastName', this.controls[1]);

    this.form.get('firstName').valueChanges.subscribe((value) => {
      const newVal = this.transform(value);
      this.form.controls.firstName.setValue(newVal, { emitEvent: false });
    });

    this.form.get('lastName').valueChanges.subscribe((value) => {
      const newVal = this.transform(value);
      this.form.controls.lastName.setValue(newVal, { emitEvent: false });
    });
  }

  initStep() {
    // Give first name focus
    setTimeout(() => this.firstNameField.nativeElement.focus(), 0);

    this.experiment = false; // TODO: migrate/remove 'vwo_personal_info_secure' test
    
    // check if notDebtSettlement
    this.notDebtSettlement = this.form.controls.formType.value != 'debtsettlement' && this.form.controls.formType.value != 'debtrelief';

    switch (this.form.value.maximumEquity) {
      case "yes": {
        this.cashoutPercentage = (this.form.controls.currentVA.value === 'yes' ? 1 : 0.9);
        this.cashoutAmount = this.form.controls.propertyValue.value * this.cashoutPercentage - 
                             this.form.controls.firstMortgageBalance.value;
        this.form.controls.cashOut.setValue(this.cashoutAmount);
      }
    }
    if (this.form.controls.formType.value == "homeimprovement") {
      this.form.controls.cashOutReason.setValue("home-improvement");
    }

    if (!environment.production) {
      this.form.controls.firstName.setValue(this.randomService.consumer.firstName);
      this.form.controls.lastName.setValue(this.randomService.consumer.lastName);
    }
  }

  submit() {
    // trimming spaces in name and last name
    this.firstNameField.nativeElement.value = this.firstNameField.nativeElement.value.trim();
    this.lastNameField.nativeElement.value = this.lastNameField.nativeElement.value.trim();
    super.submit();
  }

  transform(result: string) {
    result = result.replace('’', '\'');
    result = result.replace(this.regex, '');

    //Removing any double symbols
    result = result.replace(/\s\s+/g, ' ');
    result = result.replace(/''+/g, '\'');
    result = result.replace(/``+/g, '\`');

    return result.replace(/--+/g, '-');
  }
}
